import React from "react";
import { Box } from "@mui/material";
import MetricCard from "../../Executive/MetricCard";
import {
  COMPLETION_RATE_CAPTION,
  EcosystemPartner,
  EcosystemTotals,
  completionRateOf,
} from "./ecosystemApi";
import { GREEN, INDIGO, PRIMARY, percentText } from "./parts";

/**
 * Totals recomputed from whatever partner set is on screen, so the per-kind
 * Resource / B2B tabs each get their own headline numbers.
 */
export const totalsFor = (partners: EcosystemPartner[]): EcosystemTotals => {
  const byStatus: { [status: string]: number } = {};
  let referrals = 0;
  partners.forEach((partner) => {
    referrals += partner.total;
    Object.keys(partner.byStatus).forEach((status) => {
      byStatus[status] = (byStatus[status] || 0) + (partner.byStatus[status] || 0);
    });
  });
  return {
    referrals,
    completed: byStatus["completed"] || 0,
    completionRate: completionRateOf(byStatus),
    partners: partners.length,
  };
};

const StatRow: React.FC<{
  totals: EcosystemTotals;
  loading?: boolean;
  /** Names the partner kind in the "Active Partners" caption. */
  partnerNoun?: string;
}> = ({ totals, loading, partnerNoun }) => {
  const dash = (value: string | number) => (loading ? "—" : value);
  const cards = [
    {
      label: "Total Referrals",
      value: dash(totals.referrals.toLocaleString()),
      accent: PRIMARY,
      sub: undefined as string | undefined,
    },
    {
      label: "Completed",
      value: dash(totals.completed.toLocaleString()),
      accent: GREEN,
      sub: undefined,
    },
    {
      label: "Completion Rate",
      value: dash(percentText(totals.completionRate)),
      accent: GREEN,
      sub: COMPLETION_RATE_CAPTION,
    },
    {
      label: "Active Partners",
      value: dash(totals.partners.toLocaleString()),
      accent: INDIGO,
      sub: `${partnerNoun || "partners"} that received at least one referral`,
    },
  ];

  return (
    <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
      {cards.map((card) => (
        <Box key={card.label} sx={{ flex: "1 1 180px" }}>
          <MetricCard
            label={card.label}
            value={card.value}
            accent={card.accent}
            sub={card.sub}
          />
        </Box>
      ))}
    </Box>
  );
};

export default StatRow;
